import React from 'react'

const Image = props => <img {...props} />

export default Image
